export const siteContent = {
  intro: {
    subscribeToOur: "Subscribe to our",
    newsletter: "Newsletter",
  },
  socialMedia: [
    {
      title: "Facebook",
      href: "https://www.facebook.com/resetprojectmed",
      img: "/images/icons/facebook.svg",
    },
    {
      title: "Twitter",
      href: "https://twitter.com/RESETProjectMED",
      img: "/images/icons/twitter.svg",
    },
  ],
  disclaimer: {
    title: "Privacy and Data Protection",
    content: `By subscribing to our newsletter, you are providing us with your consent
    to send you emails related to the RESET project including news, events,
    relevant insights, and opportunities. Your personal information will not
    be used for any other purpose or shared with any third party. Should you
    need further information or have any inquiries on the protection of your
    data, please contact <a href="mailto:reset@leadersinternational.org" class="text-blue-500 cursor-pointer hover:underline">
    reset@leadersinternational.org</a>, you can unsubscribe at any time by clicking the link in the footer of our emails.`,
  },
  bySubscribing: {
    title: "By subscribing, your will receive",
    content: [
      {
        title: "The latest news and national updates about the project",
        img: "/images/icons/newsletter.svg",
      },
      {
        title: "Thematic insights",
        img: "/images/icons/insights.svg",
      },
      {
        title: "Online and offline events",
        img: "/images/icons/events.svg",
      },
      {
        title: "Consultancy and job opportunities",
        img: "/images/icons/training.svg",
      },
    ],
  },
  about: {
    title: "About",
    content: [
      {
        title:
          "RESET project is funded by the European Union under the ENI CBC MED Programme with 1 M€",
      },
      {
        title:
          "RESET aims to offer support to entrepreneurial ecosystems and initiatives that promote green and circular entrepreneurship",
      },
      {
        title:
          "Project partners are based in Greece, Italy, Lebanon, Palestine,Spain, and Tunisia",
      },
    ],
  },
  projectPartners: {
    title: "Project partners",
  },
  errorMessage: {
    content: "Please enter a valid email address.",
  },
};
